import $ from "jquery";
import ReportPlayerIssue from './ReportPlayerIssue';
import ReportContentIssue from './ReportContentIssue';

export default class ReportIssue {
  constructor({ $element: $element }) {
    this.$element = $element;

    this.selector = {
      reportTypesContainer: ".report-abuse-types-container",
      reportTypesPlayerIssue: ".report-abuse-types__item--player-issue",
      reportTypesContentIssue: ".report-abuse-types__item--content-issue",
    };

    this.page = this.$element.attr('data-page');
    this.ui = {};
    this.playerIssue = new ReportPlayerIssue({$element});
    this.contentIssue = new ReportContentIssue({$element});

    Object.keys(this.selector).forEach((key) => {
      this.ui[key] = $(this.selector[key]);
    });
  }

  init() {
    this.bindElementClick();
    this.bindContentIssueTypeClick();
    this.bindPlayerIssueTypeClick();
    this.playerIssue.init();
    this.contentIssue.init();
  }

  bindElementClick(){
    this.$element.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if(this.page == 'watchpage'){
        this.toggleReportTypesContainer();
      }else{
        this.contentIssue.showForm();
      }
    });
  }

  bindContentIssueTypeClick(){
    this.ui.reportTypesContentIssue.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.contentIssue.showForm();
    });
  }

  bindPlayerIssueTypeClick(){
    this.ui.reportTypesPlayerIssue.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.playerIssue.showForm();
    });
  }

  toggleReportTypesContainer() {
    if(this.ui.reportTypesContainer.is(':visible')){
      this.ui.reportTypesContainer.hide();
    } else {
      this.ui.reportTypesContainer.show();
    }
  }
}
